import { IHomeWhatsNewItem } from "../../app/models/HomeModal";
import { useEffect } from 'react';
import { useAppSelector } from "../../app/hooks";
import { selectResourceId } from "../../app/auth/createAuthSlice";
import { useLazyGetHomeWhatsNewQuery } from "../../app/appApiSlice";

import ActionableCardItem from "./ActionableCardItem";
import SkeletonList from "../../components/Skelton/SkeletonList";
import SkeletonCard from "../../components/Skelton/SkeletonCard";

const ActionableCardList = () => {
const resourceId = useAppSelector(selectResourceId);
const [getHomeWhatsNewData, { data: homeWhatsNewData, isLoading: isWhatsNewLoading, error: whatsNewError }] = useLazyGetHomeWhatsNewQuery();

    useEffect(() => { 
        if(resourceId){
        getHomeWhatsNewData(resourceId);
        }
      }, []);

  return (
    <div className=" ">
      <div className='mt-10'>
        <h2 className='font-bold text-xl'> What's new</h2>
        <p className="text-sm text-subParaText font-regular mb-5"> Stay up to date with the latest announcements, opportunities and insights, specially curated for you.</p>
        
        {/* <div className="flex flex-wrap flex-col md:flex-row md:space-y-0 sm:space-y-3 gap-3">
          
          {homeWhatsNewData && homeWhatsNewData.length > 0 ? (
            homeWhatsNewData.map((post: IHomeWhatsNewItem, index) => (
              <ActionableCardItem key={index} Posts={post} />
            ))
          ) : (
            <div className="text-gray-300 text-xs ml-4">No users</div>
          )} 

        </div> */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
          {isWhatsNewLoading ? ( 
            <SkeletonList count={6}>
              {(i) => <SkeletonCard key={i} />}
            </SkeletonList>
          ) : homeWhatsNewData && homeWhatsNewData.length > 0 ? ( 
            homeWhatsNewData.map((post: IHomeWhatsNewItem, index) => (
              <ActionableCardItem key={index} Posts={post} />
            ))
          ) : ( 
            <div className="col-span-full text-gray-300 text-xs text-center">
              No users
            </div>
          )}
        </div>



      </div>
    </div>
  );
};

export default ActionableCardList;
